import {defineMessages} from 'react-intl'

export const TRUSTPILOT_REVIEWS_URL =
  'https://www.trustpilot.com/review/vio.com'

export const TRUSTPILOT_LABELS = defineMessages({
  reviews: {
    id: 'trustpilot.reviews',
    defaultMessage:
      '{totalReviews, plural, one {# review} other {# reviews}} on {icon}'
  },
  score: {
    id: 'trustpilot.score',
    defaultMessage: '{score} out of 5'
  },
  great: {
    id: 'trustpilot.great',
    defaultMessage: 'Great'
  },
  excellent: {
    id: 'trustpilot.excellent',
    defaultMessage: 'Excellent'
  },
  average: {
    id: 'trustpilot.average',
    defaultMessage: 'Average'
  },
  poor: {
    id: 'trustpilot.poor',
    defaultMessage: 'Poor'
  },
  bad: {
    id: 'trustpilot.bad',
    defaultMessage: 'Bad'
  },
  invalidScore: {
    id: 'trustpilot.invalidScore',
    defaultMessage: 'Invalid Score'
  },
  reviewsCount: {
    id: 'reviewsCount',
    defaultMessage: '{reviews, plural, one {# review} other {# reviews}}'
  },
  trustScore: {
    id: 'trustpilot.trustScore',
    defaultMessage: 'TrustScore'
  },
  verifiedReviews: {
    id: 'trustpilot.verifiedReviews',
    defaultMessage:
      '{reviews, plural, one {1 verified customer review} other {# verified customer reviews}}'
  }
})
